import i18n from '@/locale/i18n'
import Moment from 'moment'
import axios from '@/axios'

const state = {
  videoList: [],
}

const getters = {

}

const actions = {
  // 获取视频列表
  async loadVideoList (context, { module }) {
    console.log(module)
    await axios.get(`/v1/api/eas/activity/list`, { module }).then((res) => {
      console.log(res)
        context.commit('updateVideoList', res.data.body.activity)
    })
  },
}

const mutations = {
  updateVideoList (state, data = []) {
    state.videoList = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/xingshan/index.js